import React, { useState, useEffect } from 'react'
import { BackupButton } from '../emprestimo/generatePdf'

const Relatorios = () => {
  const [clientes, setClientes] = useState([])
  const [clienteSelecionado, setClienteSelecionado] = useState('')
  const [emprestimos, setEmprestimos] = useState([])
  const [logs, setLogs] = useState([])
  const [loading, setLoading] = useState(true)
  const idUsuario = localStorage.getItem('idUsuario')

  useEffect(() => {
    const fetchClientes = async () => {
      try {
        setLoading(true)
        const response = await fetch(
          `https://sismoney.com/painel/database_resumo.php?idUsuario=${idUsuario}`
        )
        const data = await response.json()
        // Novo formato: { emprestimos: [...], clientes: [...] }
        if (
          data &&
          Array.isArray(data.clientes) &&
          Array.isArray(data.emprestimos)
        ) {
          setClientes(data.clientes)
          setEmprestimos(data.emprestimos)
        } else if (Array.isArray(data)) {
          // Compatibilidade com API antiga que retornava somente clientes/emprestimos em array
          setClientes(data)
        } else {
          console.error('Resposta da API de clientes não é um array', data)
        }
      } catch (error) {
        console.error('Erro ao carregar clientes:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchClientes()
  }, [idUsuario])

  const fetchLogs = async clienteNome => {
    try {
      const response = await fetch('https://sismoney.com/painel/logs.php')
      const res = await response.json()
      const filteredLogs = res.filter(
        log => log.idUsuario == idUsuario && log.nome === clienteNome
      )
      console.log(filteredLogs)
      setLogs(
        filteredLogs.map(log => ({
          data: log.dataPagamento || 'Sem data',
          usuario: log.nome || 'Desconhecido',
          acao: log.descricao || 'Sem ação',
          valor: log.valor || ' VALOR DESCONHECIDO',
          juros: log.juros || 'JUROS DESCONHECIDO'
        }))
      )
    } catch (error) {
      console.error('Erro ao buscar logs:', error)
    }
  }

  const handleClienteChange = async event => {
    const clienteId = event.target.value
    setClienteSelecionado(clienteId)
    const cliente = clientes.find(c => String(c.id) === String(clienteId))
    console.log(clienteId)
    console.log(cliente)
    if (cliente) {
      // Filtra os empréstimos que vieram do endpoint pelos clientes
      const filtrados = emprestimos.filter(e => {
        // preferir idCliente quando disponível
        if (e.idCliente !== undefined && e.idCliente !== null) {
          return String(e.idCliente) === String(cliente.id)
        }
        // fallback por nome
        return String(e.nome).trim() === String(cliente.nome).trim()
      })
      setEmprestimos(filtrados)
      console.log(emprestimos)
      await fetchLogs(cliente.nome)
    }
  }

  const clientesUnicos = Array.from(new Set(clientes.map(c => c.nome))).map(
    nome => clientes.find(c => c.nome === nome)
  )

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800 dark:text-white">
        Relatório de Empréstimos
      </h2>
      <BackupButton emprestimos={emprestimos} logs={logs} />
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6">
        <label className="text-gray-700 dark:text-gray-200 block mb-2">
          Selecione o Cliente:
        </label>
        <select
          value={clienteSelecionado}
          onChange={handleClienteChange}
          className="w-full p-2 border rounded-md bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white"
        >
          <option value="">Selecione um cliente</option>
          {clientesUnicos.map(cliente => (
            <option key={cliente.id} value={cliente.id}>
              {cliente.nome}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default Relatorios
